<template>
  <v-menu offset-y>
    <template #activator="{ props: menuProps }">
      <v-btn
          size="small"
          color="primary"
          v-bind="menuProps"
          data-testid="grid-actions-menu"
      >
        <v-icon :size="size">
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <v-list data-testid="grid-actions-menu-list">
      <v-list-item
          v-for="(item, index) in menu_items"
          style="cursor: pointer"
          :key="index"
          :data-testid="'grid-menu-item-' + index"
          @click="runItem(item)"
      >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    menu_items: {
      required: true
    },
    icon: {
      type: String,
      default: 'fas fa-bars'
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  name: "DropdownMenu",
  methods: {
    runItem(item) {
      if (item && typeof item.on_click === 'function') {
        item.on_click();
      }
    },
  },
}
</script>

<style scoped>
</style>
